/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelAgencyLink.ts                    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/general/agency-link";

export class AutogenModelAgencyLink<RowType extends ModelRow> extends Endpoint<RowType, RowAgencyLinkFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowAgencyLink extends ModelRow<RowAgencyLinkFields> {
	constructor(values?: Partial<RowAgencyLinkFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowAgencyLinkFields {
	"agency.address1": string;
	"agency.address2": string;
	"agency.agency_name": string;
	"agency.city": string;
	"agency.company_id": string;
	"agency.fax_number": string;
	"agency.id": string;
	"agency.is_active": string;
	"agency.payee": string;
	"agency.phone_number": string;
	"agency.revenue_code_id": string;
	"agency.salesperson_id": string;
	"agency.seg_allocation_cod": string;
	"agency.state": string;
	"agency.website": string;
	"agency.zip": string;
	agency_id: string;
	comm_dispatcher_role: string;
	comm_order_entry_role: string;
	commission_role: string;
	commissions_split_percent: number;
	company_id: string;
	description: string;
	effective_date: Date;
	id: string;
	is_commissions_resp_code: string;
	is_primary: boolean;
	pay_commissions_when: string;
	row_id: string;
	row_type: string;
}

